export default __webpack_public_path__ + "static/assets/im_state_box.10aaa370bd5392dd1f9a85479c334be9.png";